var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 7.81249C2.25 5.4143 2.25 4.21521 2.53314 3.81181C2.81627 3.4084 3.94374 3.02247 6.19868 2.25059L6.62829 2.10354C7.80374 1.70118 8.39146 1.5 9 1.5C9.60854 1.5 10.1963 1.70118 11.3717 2.10354L11.8013 2.25059C14.0563 3.02247 15.1837 3.4084 15.4669 3.81181C15.75 4.21521 15.75 5.4143 15.75 7.81249V8.99352C15.75 13.2221 12.5708 15.2741 10.5761 16.1455C10.035 16.3818 9.76444 16.5 9 16.5C8.23556 16.5 7.96501 16.3818 7.42392 16.1455C5.42922 15.2741 2.25 13.2221 2.25 8.99352V7.81249ZM10.5 6.75C10.5 7.57843 9.82843 8.25 9 8.25C8.17157 8.25 7.5 7.57843 7.5 6.75C7.5 5.92157 8.17157 5.25 9 5.25C9.82843 5.25 10.5 5.92157 10.5 6.75ZM9 12.75C12 12.75 12 12.0784 12 11.25C12 10.4216 10.6569 9.75 9 9.75C7.34315 9.75 6 10.4216 6 11.25C6 12.0784 6 12.75 9 12.75Z",
    fill: "#325CCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.7a0525e8.svg";
export { ForwardRef as ReactComponent };